/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_GetPurchaseDto } from '../models/PagedResultDto_GetPurchaseDto';
import type { PagedResultDto_PurchaseOutputListDto } from '../models/PagedResultDto_PurchaseOutputListDto';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_EsppPurchaseCreateDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_EsppPurchaseCreateDto';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_EsppPurchaseInfoDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_EsppPurchaseInfoDto';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseItemDetailDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseItemDetailDto';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputDto';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputListDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputListDto';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseTransactionDetailDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseTransactionDetailDto';
import type { Wealthlane_AwardService_EsppAwards_EsppPurchaseEntities_EsppPurchase } from '../models/Wealthlane_AwardService_EsppAwards_EsppPurchaseEntities_EsppPurchase';
import type { Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EsppPurchaseService {

    /**
     * @param purchasePeriodId 
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAwardPurchasePeriodPurchase(
purchasePeriodId: string,
requestBody?: Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_EsppPurchaseCreateDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/award/purchase-period/{purchasePeriodId}/purchase',
            path: {
                'purchasePeriodId': purchasePeriodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchasePeriodId 
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_EsppPurchaseInfoDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardPurchasePeriodPurchase(
purchasePeriodId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_EsppPurchaseInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/purchase-period/{purchasePeriodId}/purchase',
            path: {
                'purchasePeriodId': purchasePeriodId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchasePeriodId 
     * @param purchaseId 
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static patchApiAwardApiAwardPurchasePeriodPurchase(
purchasePeriodId: string,
purchaseId: string,
requestBody?: Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_EsppPurchaseCreateDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/award/api/award/purchase-period/{purchasePeriodId}/purchase/{purchaseId}',
            path: {
                'purchasePeriodId': purchasePeriodId,
                'purchaseId': purchaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchasePeriodId 
     * @param purchaseId 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAwardPurchasePeriodPurchase(
purchasePeriodId: string,
purchaseId: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/award/purchase-period/{purchasePeriodId}/purchase/{purchaseId}',
            path: {
                'purchasePeriodId': purchasePeriodId,
                'purchaseId': purchaseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchasePeriodId 
     * @param purchaseId 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static patchApiAwardApiAwardPurchasePeriodPurchaseStatusPublish(
purchasePeriodId: string,
purchaseId: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/award/api/award/purchase-period/{purchasePeriodId}/purchase/{purchaseId}/status/publish',
            path: {
                'purchasePeriodId': purchasePeriodId,
                'purchaseId': purchaseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseId 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAwardPurchasePublish(
purchaseId: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/award/purchase/{purchaseId}/publish',
            path: {
                'purchaseId': purchaseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchasePeriodId 
     * @param purchaseId 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static patchApiAwardApiAwardPurchasePeriodPurchaseStatusDraft(
purchasePeriodId: string,
purchaseId: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/award/api/award/purchase-period/{purchasePeriodId}/purchase/{purchaseId}/status/draft',
            path: {
                'purchasePeriodId': purchasePeriodId,
                'purchaseId': purchaseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @param searchKeyWord 
     * @param name 
     * @param purchaseStatusName 
     * @param purchaseDate 
     * @param purchaseStatusId 
     * @returns PagedResultDto_GetPurchaseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardPurchasePurchaseList(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
searchKeyWord?: string,
name?: string,
purchaseStatusName?: string,
purchaseDate?: string,
purchaseStatusId?: number,
): CancelablePromise<PagedResultDto_GetPurchaseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/purchase/purchase-list',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
                'SearchKeyWord': searchKeyWord,
                'Name': name,
                'PurchaseStatusName': purchaseStatusName,
                'PurchaseDate': purchaseDate,
                'PurchaseStatusId': purchaseStatusId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseId 
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardPurchasePurchaseSummary(
purchaseId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/purchase/{purchaseId}/purchase-summary',
            path: {
                'purchaseId': purchaseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseId 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_PurchaseOutputListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardPurchasePurchaseDetail(
purchaseId: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_PurchaseOutputListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/purchase/{purchaseId}/purchase-detail',
            path: {
                'purchaseId': purchaseId,
            },
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseItemId 
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseItemDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardPurchaseItemPurchaseItemDetail(
purchaseItemId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseItemDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/purchase-item/{purchaseItemId}/purchase-item-detail',
            path: {
                'purchaseItemId': purchaseItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseItemId 
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseTransactionDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardPurchaseItemTransactionDetail(
purchaseItemId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseTransactionDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/purchase-item/{purchaseItemId}/transaction-detail',
            path: {
                'purchaseItemId': purchaseItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseItemId 
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardPurchaseItemAwardDetail(
purchaseItemId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/purchase-item/{purchaseItemId}/award-detail',
            path: {
                'purchaseItemId': purchaseItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId 
     * @param purchasePeriodId 
     * @param enrollmentStatus 
     * @param esppParticipantId 
     * @param autoEnrollments 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriodPurchasePeriodPurchaseExport(
offeringPeriodId: string,
purchasePeriodId: string,
enrollmentStatus?: Array<string>,
esppParticipantId?: string,
autoEnrollments?: boolean,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period/{purchasePeriodId}/purchase/export',
            path: {
                'offeringPeriodId': offeringPeriodId,
                'purchasePeriodId': purchasePeriodId,
            },
            query: {
                'EnrollmentStatus': enrollmentStatus,
                'EsppParticipantId': esppParticipantId,
                'AutoEnrollments': autoEnrollments,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId 
     * @param purchasePeriodId 
     * @param formData 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAwardOfferingPeriodPurchasePeriodPurchaseImport(
offeringPeriodId: string,
purchasePeriodId: string,
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period/{purchasePeriodId}/purchase/import',
            path: {
                'offeringPeriodId': offeringPeriodId,
                'purchasePeriodId': purchasePeriodId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchasePeriodId 
     * @param requestBody 
     * @returns Wealthlane_AwardService_EsppAwards_EsppPurchaseEntities_EsppPurchase OK
     * @throws ApiError
     */
    public static postApiAwardApiAppEsppPurchase(
purchasePeriodId?: string,
requestBody?: Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_EsppPurchaseCreateDto,
): CancelablePromise<Wealthlane_AwardService_EsppAwards_EsppPurchaseEntities_EsppPurchase> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/espp-purchase',
            query: {
                'purchasePeriodId': purchasePeriodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchasePeriodId 
     * @param purchaseId 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static putApiAwardApiAppEsppPurchase(
purchasePeriodId?: string,
purchaseId?: string,
requestBody?: Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_EsppPurchaseCreateDto,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/espp-purchase',
            query: {
                'purchasePeriodId': purchasePeriodId,
                'purchaseId': purchaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseId 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppEsppPurchase(
purchaseId?: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/espp-purchase',
            query: {
                'purchaseId': purchaseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseId 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppEsppPurchaseMarkAsDraft(
purchaseId: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/espp-purchase/mark-as-draft/{purchaseId}',
            path: {
                'purchaseId': purchaseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseId 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppEsppPurchaseMarkAsPublished(
purchaseId: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/espp-purchase/mark-as-published/{purchaseId}',
            path: {
                'purchaseId': purchaseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @param searchKeyWord 
     * @param name 
     * @param purchaseStatusName 
     * @param purchaseDate 
     * @param purchaseStatusId 
     * @returns PagedResultDto_GetPurchaseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppEsppPurchasePurchaseList(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
searchKeyWord?: string,
name?: string,
purchaseStatusName?: string,
purchaseDate?: string,
purchaseStatusId?: number,
): CancelablePromise<PagedResultDto_GetPurchaseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/espp-purchase/purchase-list',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
                'SearchKeyWord': searchKeyWord,
                'Name': name,
                'PurchaseStatusName': purchaseStatusName,
                'PurchaseDate': purchaseDate,
                'PurchaseStatusId': purchaseStatusId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseId 
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppEsppPurchasePurchaseSummary(
purchaseId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/espp-purchase/purchase-summary/{purchaseId}',
            path: {
                'purchaseId': purchaseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseId 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_PurchaseOutputListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppEsppPurchasePurchaseDetail(
purchaseId: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_PurchaseOutputListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/espp-purchase/purchase-detail/{purchaseId}',
            path: {
                'purchaseId': purchaseId,
            },
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseItemId 
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseItemDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppEsppPurchasePurchaseItemDetail(
purchaseItemId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseItemDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/espp-purchase/purchase-item-detail/{purchaseItemId}',
            path: {
                'purchaseItemId': purchaseItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseItemId 
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseTransactionDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppEsppPurchaseTransactionDetail(
purchaseItemId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseTransactionDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/espp-purchase/transaction-detail/{purchaseItemId}',
            path: {
                'purchaseItemId': purchaseItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseItemId 
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppEsppPurchaseAwardDetail(
purchaseItemId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/espp-purchase/award-detail/{purchaseItemId}',
            path: {
                'purchaseItemId': purchaseItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseId 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppEsppPurchasePublishPurchase(
purchaseId: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/espp-purchase/publish-purchase/{purchaseId}',
            path: {
                'purchaseId': purchaseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseId 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppEsppPurchasePublishPurchaseInternal(
purchaseId: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/espp-purchase/publish-purchase-internal/{purchaseId}',
            path: {
                'purchaseId': purchaseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
